import { render, staticRenderFns } from "./EditProducerGeneralSetting.vue?vue&type=template&id=475a76dc&scoped=true&"
import script from "./EditProducerGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./EditProducerGeneralSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a76dc",
  null
  
)

export default component.exports